import { useNavigate } from "react-router-dom";
import { Lock, Crown } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface PremiumUpgradeDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  feature: string;
}

export default function PremiumUpgradeDialog({
  open,
  onOpenChange,
  feature,
}: PremiumUpgradeDialogProps) {
  const navigate = useNavigate();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="flex items-center gap-3 mb-2">
            <div className="p-2 bg-yellow-100 dark:bg-yellow-900/30 rounded-full">
              <Crown className="w-6 h-6 text-yellow-600 dark:text-yellow-400" />
            </div>
            <DialogTitle>Premium Feature</DialogTitle>
          </div>
          <DialogDescription className="text-left">
            <strong>{feature}</strong> is available with a premium subscription.
            Upgrade to unlock all techniques, practice modes, tournaments, and
            more.
          </DialogDescription>
        </DialogHeader>
        <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4 space-y-2">
          <div className="flex items-center gap-2 text-sm">
            <Lock className="w-4 h-4 text-yellow-600" />
            <span>All 90+ mental math techniques</span>
          </div>
          <div className="flex items-center gap-2 text-sm">
            <Lock className="w-4 h-4 text-yellow-600" />
            <span>Combined Forms & Time Trial modes</span>
          </div>
          <div className="flex items-center gap-2 text-sm">
            <Lock className="w-4 h-4 text-yellow-600" />
            <span>Tournaments & leaderboards</span>
          </div>
          <div className="flex items-center gap-2 text-sm">
            <Lock className="w-4 h-4 text-yellow-600" />
            <span>Personalized learning path</span>
          </div>
        </div>
        <DialogFooter className="flex gap-2 sm:gap-0">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Maybe Later
          </Button>
          <Button
            onClick={() => {
              onOpenChange(false);
              navigate("/pricing");
            }}
            className="bg-gradient-to-r from-yellow-500 to-orange-500 hover:from-yellow-600 hover:to-orange-600 text-white"
          >
            View Plans
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
